import { render, staticRenderFns } from "./TortaMix.vue?vue&type=template&id=ee1581ce&"
import script from "./TortaMix.vue?vue&type=script&lang=js&"
export * from "./TortaMix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports